import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import IMatchRuleDto from '@core/mappers/offer/dtos/IMatchRuleDto';
import Rule from '@core/models/shared/betSlip/Rule';

export default class MatchRuleMapper extends AbstractMapper<IMatchRuleDto, Rule> {

    createTargetObject(dto: IMatchRuleDto, key: string): Rule {
        const rule: Rule = new Rule();

        rule.name = dto.name;
        rule.modifier = dto.modifier;
        rule.param1 = dto.param1;
        rule.param2 = dto.param2;

        return rule;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/offer/MatchRuleMapper.ts